import { combineReducers } from 'redux';

// Reducers
import authReducer from './authReducer';
import organizationReducer from './organizationReducer';
import areasReducer from './areasReducer';
import filesReducer from './filesReducer';
import globalReducer from './globalReducer';
import usersReducer from './usersReducer';
import staffsReducer from './staffsReducer';

export default combineReducers ({
	auth: authReducer,
	organization: organizationReducer,
	areas: areasReducer,
	trainingFiles: filesReducer,
	global: globalReducer,
	users: usersReducer,
	staffs: staffsReducer
});
